var _a, _b;
export var ALL = 'Összes';
export var TEAM = 'Csapatom';
export var MINE = 'Sajátom';
var taskFilter = (_a = {},
    _a[ALL] = function (task, store) { return true; },
    _a[TEAM] = function (task, store) { return store.employees.some(function (id) { return id === task.userId; }); },
    _a[MINE] = function (task, store) { return task.userId === store.userId; },
    _a);
var userFilter = (_b = {},
    _b[ALL] = function (store) { return store.users; },
    _b[TEAM] = function (store) { return store.users.filter(function (i) { return store.employees.some(function (e) { return e === i.id; }); }); },
    _b[MINE] = function (store) { return store.users.filter(function (i) { return i.id === store.userId; }); },
    _b);
export function getViewOptions() {
    return [MINE, ALL, TEAM];
}
export function getViewOptionFilter(type) {
    return taskFilter[type] || taskFilter[ALL];
}
export function getUserFilter(type) {
    return userFilter[type] || userFilter[ALL];
}



//////////////////
// WEBPACK FOOTER
// ./src/models/TaskViewOptions.ts
// module id = 68
// module chunks = 0